import { useNavigate } from "react-router-dom";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Typography, Popover, Divider, IconButton } from "@mui/material";

import "../header/header.scss";
import styles from "./header.style";
import useHeaderHelper from "./helper";
import { RootState } from "../../redux/store";
import { appendImageUrl } from "../../common/utils";
import { IMAGES, Paths } from "../../common/constants";
import { toggleSidebar } from "../../redux/global.slice";
import ConfirmationModal from "../modal/confirmationModal";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";

const Header = () => {
  const {
    id,
    open,
    anchorEl,
    hasCartItem,
    isUserAdmin,
    myProfileData,
    isCartNotVisible,
    isConfirmationOpen,
    canViewCompanyProfile,

    handleClick,
    handleClose,
    handleProfile,
    handleSubscription,
    handleConfirmLogout,
    handleClickCartIcon,
    handleMyAccountClick,
    handleComapanyProfile,
    handleHelpCenterClick,
    handleConfirmationOpen,
    handleConfirmationClose,
  } = useHeaderHelper();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const sidebarCollapsed = useAppSelector(
    (state: RootState) => state.globalcontent.sidebarCollapsed,
  );

  const storedProfile = localStorage.getItem("profile");
  const validStoredProfile =
    storedProfile && storedProfile !== "null" && storedProfile !== "undefined";

  return (
    <Box className="header-container">
      <Box
        className="header-left-container"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <IconButton
          onClick={() => dispatch(toggleSidebar())}
          aria-label="toggle sidebar"
          className="hamburger-btn"
          disableRipple
        >
          <Box
            className={`hamburger-icon ${
              sidebarCollapsed ? "collapsed" : "expanded"
            }`}
            sx={{
              width: 24,
              height: 24,
              backgroundColor: "currentColor",
              mask: `url(${
                sidebarCollapsed
                  ? IMAGES.PanelRightClose.startsWith("../")
                    ? IMAGES.PanelRightClose.substring(2)
                    : IMAGES.PanelRightClose
                  : IMAGES.PanelRightOpen.startsWith("../")
                    ? IMAGES.PanelRightOpen.substring(2)
                    : IMAGES.PanelRightOpen
              }) no-repeat center / contain`,
              WebkitMask: `url(${
                sidebarCollapsed
                  ? IMAGES.PanelRightClose.startsWith("../")
                    ? IMAGES.PanelRightClose.substring(2)
                    : IMAGES.PanelRightClose
                  : IMAGES.PanelRightOpen.startsWith("../")
                    ? IMAGES.PanelRightOpen.substring(2)
                    : IMAGES.PanelRightOpen
              }) no-repeat center / contain`,
            }}
          />
        </IconButton>
        <Box
          component="img"
          src={IMAGES.DatabisLogo}
          alt="logo"
          sx={styles.logo}
          onClick={() => navigate(Paths.LOGIN)}
          onKeyPress={(event: any) => {
            if (event.key === "Enter") {
              navigate(Paths.LOGIN);
            }
          }}
          tabIndex={0}
        />
      </Box>
      <Box sx={styles.wrap}>
        {/* Cart */}
        {!isCartNotVisible && (
          <Box
            className="cart-icon-container"
            sx={styles.notification}
            onClick={handleClickCartIcon}
          >
            <img src={IMAGES.CartIcon} alt="Cart Icon" />
            {hasCartItem && <span className="cart-icon-symbol"></span>}
          </Box>
        )}

        {/* Notification */}
        {/* <Box sx={styles.notification} onClick={handleClickNotification}>
          <img src={IMAGES.Notification} alt="Notification Icon" />
        </Box> */}

        {/* Profile Dropdown */}
        <Box
          sx={styles.profileContainer}
          onClick={handleClick}
          onKeyPress={(event) => {
            if (event.key === "Enter") handleClick(event);
          }}
        >
          {/* Profile Image Priority: storedProfile > API profilePicture > Placeholder */}
          {validStoredProfile ? (
            <Box
              component="img"
              src={String(storedProfile)}
              alt="Profile"
              sx={styles.profileImg}
              tabIndex={0}
            />
          ) : myProfileData.profilePicture ? (
            <Box sx={styles.avtar} className="avtar">
              <img
                src={appendImageUrl(myProfileData.profilePicture)}
                alt="Avatar"
              />
            </Box>
          ) : (
            <Box sx={styles.avtar} className="avtar">
              <img src={IMAGES.profilePlaceholder} alt="Avatar" />
            </Box>
          )}

          {/* Name right after profile picture */}
          <Typography tabIndex={0} sx={styles.name}>
            {myProfileData.firstName ? myProfileData.firstName : ""}
            {/* {myProfileData.lastName ? ` ${myProfileData.lastName}` : ""} */}
          </Typography>

          {/* Dropdown Arrow */}
          {open ? (
            <ArrowDropUpIcon tabIndex={0} sx={styles.arrow} />
          ) : (
            <ArrowDropDownIcon tabIndex={0} sx={styles.arrow} />
          )}
        </Box>
      </Box>

      {/* Popover - Profile Menu */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={0}
        sx={styles.popOver}
        disableScrollLock
      >
        <Box sx={styles.actionContainer}>
          <Typography onClick={handleProfile}>
            <Box className="headerMenuList">
              <img src={IMAGES.MenuUser} alt="" />
              <Typography
                tabIndex={0}
                className="headerMenuTxt"
                sx={styles.actionTitle}
                onKeyPress={(event) => {
                  if (event.key === "Enter") handleProfile();
                }}
              >
                My Profile
              </Typography>
            </Box>
          </Typography>

          {isUserAdmin && (
            <>
              <Typography onClick={handleSubscription}>
                <Box className="headerMenuList">
                  <img src={IMAGES.MySubscriptionIcon} alt="" />
                  <Typography
                    tabIndex={0}
                    className="headerMenuTxt"
                    sx={styles.actionTitle}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") handleSubscription();
                    }}
                  >
                    My Subscription
                  </Typography>
                </Box>
              </Typography>

              <Typography onClick={handleMyAccountClick}>
                <Box className="headerMenuList">
                  <img src={IMAGES.MyAccountIcon} alt="" />
                  <Typography
                    tabIndex={0}
                    className="headerMenuTxt"
                    sx={styles.actionTitle}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") handleMyAccountClick();
                    }}
                  >
                    My Accounts
                  </Typography>
                </Box>
              </Typography>
            </>
          )}

          {canViewCompanyProfile && (
            <Typography onClick={handleComapanyProfile}>
              <Box className="headerMenuList">
                <img src={IMAGES.Company} alt="" />
                <Typography
                  tabIndex={0}
                  className="headerMenuTxt"
                  sx={styles.actionTitle}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") handleComapanyProfile();
                  }}
                >
                  Company Profile
                </Typography>
              </Box>
            </Typography>
          )}

          <Typography onClick={handleHelpCenterClick}>
            <Box className="headerMenuList">
              <img src={IMAGES.Help} alt="" />
              <Typography
                tabIndex={0}
                className="headerMenuTxt"
                sx={styles.actionTitle}
                onKeyPress={(event) => {
                  if (event.key === "Enter") handleHelpCenterClick();
                }}
              >
                Help Center
              </Typography>
            </Box>
          </Typography>

          <Divider sx={styles.divider} />

          <Box
            className="headerMenuList"
            onClick={() => {
              handleClose();
              handleConfirmationOpen();
            }}
          >
            <img src={IMAGES.Logout} alt="" />
            <Typography
              sx={styles.actionTitle}
              tabIndex={0}
              className="headerMenuTxt"
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleClose();
                  handleConfirmationOpen();
                }
              }}
            >
              Logout
            </Typography>
          </Box>
        </Box>
      </Popover>

      {/* Popover - Notifications */}
      {/* <Popover
        id={idNotification}
        open={openNotification}
        anchorEl={anchorElNotification}
        onClose={handleCloseNotification}
        elevation={0}
        sx={styles.popOver}
        disableScrollLock
      >
        <Box sx={styles.actionContainer}>
          <div className="notificationTitleWrapper">
            <div className="topView">
              <h4 className="title">Notifications</h4>
              <button className="link">See All</button>
            </div>
            <ul className="headerNotificationListWrapper">
              <li className="list">
                <div className="leftCol">
                  <figure className="N_Icon">
                    <img src={IMAGES.CircleLogo} alt="" />
                  </figure>
                  <div className="userInfoWrapper">
                    <h4 className="title">
                      Tokenization Request by Employee Name
                    </h4>
                    <p className="time">2m ago</p>
                  </div>
                </div>
                <p className="description">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </p>
              </li>
            </ul>
          </div>
        </Box>
      </Popover> */}

      {/* Confirmation Modal */}
      <ConfirmationModal
        open={isConfirmationOpen}
        handleClose={handleConfirmationClose}
        onClick={handleConfirmLogout}
        heading="Logout"
        yesBtnTxt="Logout"
        noBtnTxt="Cancel"
        content="Are you sure you want to logout?"
      />
    </Box>
  );
};

export default Header;
